import Api from "../Api"

export function fetchConnectedIntegrations(slug) {
  return {
    type: 'FETCH_CONNECTED_INTEGRATIONS',
    payload: Api.get(`/reports/${slug}/connected_integrations`)
  }
}
